import { useState, useEffect } from 'react';
import { clubsService } from '@/features/clubs/services/clubsService';
import type { Business } from '@/features/clubs/types/types';

export function useClubs() {
  const [clubs, setClubs] = useState<Business[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchClubs = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await clubsService.getAllClubs();
      setClubs(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch clubs');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchClubs();
  }, []);

  return { 
    clubs, 
    loading, 
    error, 
    fetchClubs 
  };
}
